import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-receiving",
  "use": "icon-receiving-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-receiving\">\n<path d=\"M4.625 5.5H13.375V6.75H4.625V5.5ZM6.5 3H11.5V4.25H6.5V3ZM1.55875 8H6.5V10.5H11.5V8H16.4412L13.1012 1.75H4.89813L1.55875 8ZM16.5 9.25H12.75V11.75H5.25V9.25H1.5V14.25H16.5V9.25ZM4.39062 0.5H13.6094C13.8698 0.512917 14.0585 0.630208 14.1756 0.851875L17.6912 7.86375C17.7304 7.955 17.75 8.05271 17.75 8.15688V14.8756C17.75 15.0581 17.6915 15.2079 17.5744 15.325C17.4573 15.4421 17.3075 15.5006 17.125 15.5006H0.875C0.6925 15.5006 0.542708 15.4421 0.425625 15.325C0.308542 15.2079 0.25 15.0581 0.25 14.8756V8.15688C0.25 8.05271 0.269583 7.955 0.30875 7.86375L3.82437 0.851875C3.94146 0.630625 4.13021 0.513333 4.39062 0.5Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/receiving.svg
// module id = keg3
// module chunks = 262